import React from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';

export function MontagePage() {
  return (
    <>
      <SEO
        title="Montageanvisning | KELFAE LOFTER ApS"
        description="Her kan du se en video demonstration af hvordan loftet monteres og hente vejledninger til korrekte installationer af akustiklofter og T-skinnesystemer."
      />

      <section className="bg-neutral-100 border-b border-neutral-200 py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <span className="text-xs font-bold uppercase tracking-widest text-neutral-900 bg-[#7FDCA7]/30 px-3 py-1 rounded-full border border-[#7FDCA7]/50 inline-block">
              Teknisk Guider
            </span>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-neutral-900 font-serif-heading tracking-tight">
              Montageanvisning
            </h1>
            <p className="text-sm sm:text-base text-neutral-600 leading-relaxed">
              Montage af lofter. Se video og teknisk dokumentation til korrekt opsætning af vores professionelle akustiklofter.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            {/* Video Demonstration Card */}
            <div className="lg:col-span-7">
              <a
                href="https://www.youtube.com/watch?v=kooz173Vr9Y"
                target="_blank"
                rel="noopener noreferrer"
                className="block relative bg-neutral-50 border border-neutral-200 rounded-2xl overflow-hidden shadow-sm group hover:border-[#7FDCA7] transition-all"
              >
                <img
                  src="https://assets.auxodev.dk/assets/6ff16b38-fa18-408f-9a5d-f4f108c00990/hqdefault.jpg"
                  alt="Installation Video Exposed System - suspended ceilings from Knauf AMF"
                  className="w-full h-80 sm:h-96 object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full bg-[#7FDCA7] text-neutral-950 flex items-center justify-center text-xl shadow-xl group-hover:scale-110 transition-transform">
                    <i className="fa-solid fa-play ml-1" aria-hidden="true" />
                  </div>
                </div>
                <div className="p-6 bg-neutral-50 border-t border-neutral-200 space-y-2">
                  <div className="flex items-center justify-between">
                    <h3 className="text-base font-bold text-neutral-900 font-serif-heading group-hover:text-[#2A8C52] transition-colors">
                      Installation Video Exposed System - Knauf AMF
                    </h3>
                    <i className="fa-solid fa-arrow-up-right-from-square text-xs text-neutral-400 group-hover:text-[#7FDCA7] transition-colors" aria-hidden="true" />
                  </div>
                  <p className="text-xs text-neutral-600">
                    Se en video demonstration af, hvordan det sænkede loft og T-skinnesystemet monteres korrekt i praksis på YouTube.
                  </p>
                </div>
              </a>
            </div>

            {/* Content & Direct Advice */}
            <div className="lg:col-span-5 space-y-6">
              <div className="space-y-4">
                <h2 className="text-2xl font-bold text-neutral-900 font-serif-heading">
                  Professionel rådgivning & montering
                </h2>
                <p className="text-xs sm:text-sm text-neutral-700 leading-relaxed">
                  Har du spørgsmål til specifikke bærende konstruktioner, udstansninger, kantudførelser (Kant SK eller Kant Tegular) eller nedhængshøjder, står vores tekniske team altid klar med vejledning.
                </p>
              </div>

              <div className="p-6 rounded-2xl bg-neutral-50 border border-neutral-200 space-y-4 shadow-sm">
                <div className="flex items-center gap-3 text-neutral-900 text-sm font-bold">
                  <i className="fa-solid fa-headset text-[#7FDCA7] text-lg" aria-hidden="true" />
                  <span>Teknisk Support</span>
                </div>
                <p className="text-xs text-neutral-600 leading-relaxed">
                  Ring direkte til os for tekniske afklaringer inden dit projekt påbegyndes:
                </p>
                <div className="space-y-2 text-xs font-semibold">
                  <a
                    href="tel:43712540"
                    className="block text-neutral-900 hover:text-[#69C892] transition-colors whitespace-nowrap"
                  >
                    <i className="fa-solid fa-phone text-[#7FDCA7] mr-2" aria-hidden="true" />
                    (+45) 43 71 25 40
                  </a>
                  <a
                    href="mailto:jlh@kelfae.dk"
                    className="block text-neutral-900 hover:text-[#69C892] transition-colors whitespace-nowrap"
                  >
                    <i className="fa-regular fa-envelope text-[#7FDCA7] mr-2" aria-hidden="true" />
                    jlh@kelfae.dk
                  </a>
                </div>
              </div>

              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#7FDCA7] hover:bg-[#69C892] text-neutral-950 font-bold text-xs rounded-xl transition-all shadow-sm"
              >
                <span>Kontakt teknisk rådgiver</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
